module.exports = __webpack_public_path__ + "img/9.bab7ff94.png";